import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

import { ReAnalysisData } from '../ReanalysisWorkflowInstancePage/ReanalysisModule/types';

const ExposureKeyChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as ReAnalysisData | null;
  const newValue = change.newValue as ReAnalysisData | null;

  return (
    <ActivityItem.Section label="Updated exposure key">
      <ActivityTagItem
        oldValue={oldValue?.exposureKey || undefined}
        newValue={newValue?.exposureKey || undefined}
      />
    </ActivityItem.Section>
  );
};

export const EXPOSURE_KEY_CHANGE_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'reanalysis-exposure-key-change',
    predicate: ({ change }) => {
      if (change.fieldPath !== '/module_data/reanalysis') return false;
      const oldValue = change.oldValue as ReAnalysisData | null;
      const newValue = change.newValue as ReAnalysisData | null;
      return oldValue?.exposureKey !== newValue?.exposureKey;
    },
    render: ExposureKeyChangeRender,
  });
